/* Preserve Impact's purchase flow; suppress the duplicate bar while the main CTA is visible. */
(() => {
  let frame = 0;
  const update = () => {
    frame = 0;
    const button = document.querySelector('.shopify-section--main-product .product-info buy-buttons button[type="submit"]');
    const rect = button?.getBoundingClientRect();
    const visible = !!rect && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0;
    document.querySelectorAll('product-quick-add').forEach(bar => {
      if (bar.hasAttribute('data-ac-main-buy-visible') !== visible) {
        bar.toggleAttribute('data-ac-main-buy-visible', visible);
      }
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  update();
})();
